import { _t } from '../base.js'

export function initThankYouPage() {
    if ($('.id--15').length) {
        moveOrderNo()
    }
}

function moveOrderNo() {
    const recapTable = document.querySelector('.recapitulation-table tbody')
    const recaNumber = document.querySelector('.reca-number')

    if (recapTable && recaNumber) {
        const newRow = document.createElement('tr')
        const labelCell = document.createElement('th')
        labelCell.textContent = _t('orderNumber')

        const valueCell = document.createElement('td')
        valueCell.appendChild(recaNumber.querySelector('strong'))

        newRow.appendChild(labelCell)
        newRow.appendChild(valueCell)

        recapTable.insertBefore(newRow, recapTable.firstChild)
        recaNumber.remove()
    }
}
